import React from "react";
import cloneDeep from "lodash/cloneDeep";
import Table from "@cloudscape-design/components/table";
import Pagination from "@cloudscape-design/components/pagination";
import Header from "@cloudscape-design/components/header";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import Grid from "@cloudscape-design/components/grid";
import Badge from "@cloudscape-design/components/badge";
import Preferences from "@cloudscape-design/components/collection-preferences";
import Alert from "@cloudscape-design/components/alert";
import Spinner from "@cloudscape-design/components/spinner";
import Select from "@cloudscape-design/components/select";
import SpaceBetween from "@cloudscape-design/components/space-between";
import FormField from "@cloudscape-design/components/form-field";
import Modal from "@cloudscape-design/components/modal";
/* Recoil */
import { useRecoilValue, useSetRecoilState } from "recoil";
import { configStore } from "../stores/config";
import { groupStore, providerStore } from "../stores/group";
import { providerEditModalStore } from "../stores/groupEditModal";
import { providerAddModalStore } from "../stores/groupAddModal";
import { groupEditModalStore } from "../stores/groupEditModal";
import { groupAddModalStore } from "../stores/groupAddModal";
import { getRecoil, setRecoil } from "recoil-nexus";
/* ------- */

class Group extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedItems: [],
		};
	}

	componentDidMount() {
		this.props.Interface.loadGroup();
	}

	handleKeyPress = (event) => {
		if (event.detail.key === "Enter") {
			this.props.setGroup({ ...this.props.group, pagination: { ...this.props.group.pagination, current: 1 } });
			setTimeout(() => {
				this.props.Interface.loadGroup();
			}, 0);
		}
	};

	async handleDeleteGroup(groupId) {
		try {
			this.props.setGroup({ ...this.props.group, loading: true, });
			await this.props.Interface.request("set", { class: "panel", module: "group", method: "delete" }, {
			 id: groupId,
			});
			this.props.Interface.loadGroup();
		} catch (error) {
			this.props.setGroup({ ...this.props.group, error });
		}
	}



	render() {
		return (
			<>
				{this.props.group.loaded && this.props.group.error.text.length ? (
					<Box
						margin={{ bottom: "m" }}
						children={
							<Alert
								type="error"
								header="Error loading data:"
								children={
									<>
										<Box variant="p" children={this.props.group.error.text} />
										<hr />
										<Box
											variant="p"
											children={
												<>
													request error code: {this.props.group.error.code} | request timestamp: {this.props.group.error.timestamp}
												</>
											}
										/>
									</>
								}
							/>
						}
					/>
				) : (
					<></>
				)}


				<Table
					stickyHeader="true"
					trackBy="id"
					loading={!this.props.group.loaded}
					sortingColumn={{ sortingField: this.props.group.sorting.sortingColumn.column }}
					sortingDescending={this.props.group.sorting.isDescending}
					onSortingChange={(sorting) => {
						this.props.setGroup({
							...this.props.group,
							sorting: {
								...this.props.group.sorting,
								sortingColumn: {
									order: !sorting.detail.isDescending ? "ASC" : "DESC",
									column: sorting.detail.sortingColumn.sortingField,
								},
								isDescending: sorting.detail.isDescending,
							},
						});
						setTimeout(() => {
							this.props.Interface.loadGroup();
						}, 250);
					}}
					columnDefinitions={[
						{
							id: "id",
							header: "ID",
							sortingField: "id",
							cell: (item) => 	<Button
								iconName={"status-in-progress"}
								className={[this.props.styles["btnUID"], typeof document.body.classList[0] !== "undefined" ? this.props.styles["dark"] : "", this.props.styles["blue"]].join(" ")}
								variant="normal"
								onClick={() => {
									this.props.setGroupEditModal({
										...this.props.groupEditModal,
										...item,
										show: true,
									});
								}}
								children={item.id}
							/>,
						},
						{ id: "name", header: "Name", sortingField: "name", cell: (item) => item.name },
						{ id: "permissions", header: "Permissions", sortingField: "permissions", cell: (item) => {
							try {
								return JSON.parse(item.permissions).length
							} catch (e) {
								return item.permissions ? item.permissions.length : 0;
							}
						}},
						{ id: "showColumn", header: "Show column", sortingField: "showColumn", cell: (item) => {
								try {
									return JSON.parse(item.showColumn).length
								} catch (e) {
									return item.showColumn ? item.showColumn.length : 0;
								}
							} },
						{ id: "description", header: "Description", sortingField: "description", cell: (item) => item.description ?? "N/A" },
						{ id: "action", header: "Action", cell: (item) =>
								<Button
									variant="icon"
									iconName="delete-marker"
									onClick={() => this.handleDeleteGroup(item.id)}
								>
									Delete
								</Button>
						}
					]}
					items={this.props.group.data}
					preferences={
						<Preferences
							cancelLabel="Cancel"
							confirmLabel="Confirm"
							pageSizePreference={{ title: "Group per page", options: this.props.config.group.preferences.perPage }}
							preferences={{ pageSize: this.props.config.group.perPage }}
							title="Preferences"
							onConfirm={(preferences) => {
								localStorage.setItem("group.perPage", preferences.detail.pageSize);
								this.props.setConfig({
									...this.props.config,
									group: { ...this.props.config.group, perPage: preferences.detail.pageSize },
								});
								setTimeout(() => {
									this.props.Interface.loadGroup();
								}, 250);
							}}
						/>
					}
					pagination={
						<Pagination
							disabled={!this.props.group.loaded}
							currentPageIndex={this.props.group.pagination.current}
							pagesCount={this.props.group.pagination.total}
							onChange={(page) => {
								this.props.setGroup({
									...this.props.group,
									pagination: { ...this.props.group.pagination, current: page.detail.currentPageIndex },
								});
								setTimeout(() => {
									this.props.Interface.loadGroup();
								}, 250);
							}}
						/>
					}
					filter={
						<Box
							margin={{ bottom: "m" }}
							children={
								<Grid
									gridDefinition={[{ colspan: 3 }, { colspan: 3 }, { colspan: 3 }, { colspan: 3 }]}
									children={
										<>
											<Select
												filteringType="auto"
												disabled={!this.props.group.loaded}
												placeholder="Type"
												selectedOption={this.props.group.currentSearchType}
												onChange={(option) => {
													option.detail.selectedOption.type !== this.props.group.currentSearchType &&
													this.props.setGroup({
														...this.props.group,
														currentSearchType: option.detail.selectedOption,
													});
												}}
												options={this.props.group.currentOption.type}
											/>
											<Input
												disabled={!this.props.group.loaded}
												onKeyDown={this.handleKeyPress}
												disableBrowserAutocorrect={true}
												placeholder="id, name"
												inputMode="search"
												type="search"
												value={this.props.group.currentSearch}
												onChange={(event) => {
													this.props.setGroup({
														...this.props.group,
														currentSearch: event.detail.value,
													});
												}}
											/>
										</>
									}
								/>
							}
						/>
					}
					header={
						<Box
							margin={{ bottom: "m" }}
							children={
								<Header
									children="Group"
									counter={<>({this.props.group.pagination.count})</>}
									actions={
										<SpaceBetween direction="horizontal" size="l">
											<Button
												disabled={!this.props.group.loaded}
												className={[this.props.styles["players-search-button"], this.props.styles["btn"]].join(" ")}
												onClick={() => {
													this.props.setGroupAddModal({
														...this.props.groupAddModal,
														show: true,
													});
												}}
												variant="primary"
												children="Add group"
											/>
										</SpaceBetween>
									}
								/>
							}
						/>
					}
					empty="No groups found with requested filter"
				/>
			</>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const group = useRecoilValue(groupStore);
		const setGroup = useSetRecoilState(groupStore);
		const config = useRecoilValue(configStore);
		const setConfig = useSetRecoilState(configStore);

		const groupEditModal = useRecoilValue(groupEditModalStore);
		const setGroupEditModal = useSetRecoilState(groupEditModalStore);


		const groupAddModal = useRecoilValue(groupAddModalStore);
		const setGroupAddModal = useSetRecoilState(groupAddModalStore);
		return (
			<Component
				{...props}
				setGroupEditModal={setGroupEditModal}
				groupEditModal={groupEditModal}
				group={group}
				setGroup={setGroup}
				groupAddModal={groupAddModal}
				setGroupAddModal={setGroupAddModal}
				config={config}
				setConfig={setConfig}
			/>
		);
	};
}

export default withRecoil(Group);
